import React,{ Suspense, useEffect, useState } from "react";
import { fetchEntry } from 'src/data/fetch'
import {  Navigate } from "react-router-dom";

const ScucessSend = ({res}) => {
    return <Navigate replace to={`/complate?id=${res.data.id}`}/>
}

const ErroSend = () => {

    return (
        <div className="complete">   
            <div className="select_desc al-c">申し訳ございません。<br/>エラーが発生し、<br/>応募を受け付けられませんでした。</div>
            <div className="w-100 mb-100">
                <img src={`${process.env.REACT_APP_HOME_URL}/images/shun.png`} />
            </div>
        </div>
    )
}

export const EntrySendView = ({InputEntry}) => {


    const [res, setRes] = useState(0)

    const formData = new FormData()
    
    formData.append('name',InputEntry.name) //名前
    formData.append('address',InputEntry.address) //住所
    formData.append('email',InputEntry.email) //メールアドレス
    formData.append('sex',InputEntry.sex) //性別
    formData.append('age',InputEntry.age) //年齢
    formData.append('family',InputEntry.family) //家族人数
    formData.append('cource',InputEntry.cource) //応募コース
    //購入商品
    formData.append('products',InputEntry.products !== null ? InputEntry.products.map(p => `${p}\n`) : '') //表示順
    formData.append('store',InputEntry.store) //購入店
    //応募商品
    formData.append('presents',InputEntry.presents !== null ? InputEntry.presents.map(p => `${p}\n`) : '') //表示順
    
    useEffect(() => {
        fetchEntry(formData).then((res) => {
            setRes(res)
        })
    },[])
    

    return (
        <>
        {
        res !== 0 &&
        <>
            {
                res.respons === 'success' && 
                <ScucessSend {...{res}}></ScucessSend>
            }
            {
                res.respons === 'error' && 
                <ErroSend></ErroSend>
            }
        </>
        }
        </>
        )
}